import React from 'react'

const AccordionsWrapper = ({ children, className, isDesktop }) => {
  if (isDesktop) return <div className={className}>{children}</div>

  return <ul className={className}>{children}</ul>
}

export default AccordionsWrapper
